import { useTruncate } from '@nesso/ui/hooks/use-truncate';
import { cn } from '@nesso/ui/lib/utils';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@nesso/ui/primitives/tooltip';

type TruncatingLineProps = {
    text: string;
    className?: string;
};

// The tooltip and the tab stop both appear only once the text overflows, so a short name is
// neither a pointless hover target nor an extra stop in the tab order.
function TruncatingLine({ text, className }: TruncatingLineProps) {
    const { ref, isTruncated } = useTruncate<HTMLSpanElement>({ dependency: text });

    const line = (
        <span
            ref={ref}
            tabIndex={isTruncated ? 0 : undefined}
            className={cn(
                'block w-full truncate',
                isTruncated &&
                    'rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset',
                className,
            )}
        >
            {text}
        </span>
    );

    if (!isTruncated) return line;

    return (
        <Tooltip>
            <TooltipTrigger asChild>{line}</TooltipTrigger>
            <TooltipContent>{text}</TooltipContent>
        </Tooltip>
    );
}

type Props = {
    name: string;
    email: string;
};

export function ReportingPagePracticeMemberUsageTableNameCell({ name, email }: Props) {
    return (
        // Local provider, matching the impersonate button: the app-level one wraps routed pages,
        // but a story or test rendering this cell in isolation has no ancestor provider.
        <TooltipProvider>
            <div className="flex min-w-0 flex-col">
                <TruncatingLine text={name} className="font-medium" />
                <TruncatingLine text={email} className="text-muted-foreground text-xs" />
            </div>
        </TooltipProvider>
    );
}
